import React from 'react';
import PropTypes from "prop-types";
import './formTitle.scss';


export default class FormTitle extends React.Component {

    constructor (props) {
        super(props);
    }

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    render () {
        return (
            <div className="formTitle">{this.context.translator(this.props.titleKey)}</div>
        );
    }
}

FormTitle.propTypes = {
    titleKey: PropTypes.string
};